import { render, staticRenderFns } from "./carFate.vue?vue&type=template&id=c3e59e1a&scoped=true&"
import script from "./carFate.vue?vue&type=script&lang=js&"
export * from "./carFate.vue?vue&type=script&lang=js&"
import style0 from "./carFate.vue?vue&type=style&index=0&id=c3e59e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e59e1a",
  null
  
)

export default component.exports